export const navbarStyles = {
  drawer: {
   // width: 260,
    flexShrink: 0,
    "& .MuiDrawer-paper": {
    //  width: 260,
      boxSizing: "border-box",
      backgroundColor: "#101F33",
      color: "rgba(255, 255, 255, 0.7)",
    },
    "& .Mui-selected": {
      //color: "#4fc3f7",
      color: "#ffffff",
      //backgroundColor: "rgba(0, 155, 229, 0.08)",
      backgroundColor: "rgba(30, 60, 114, 0.50) !important",
      fontWeight:600
    },
    "& .Mui-selected .MuiListItemIcon-root": {
      color: "#ffffff",
    }
  },
  responsiveDrawer: {
     boxSizing: 'border-box', 
     width: '260',
     position:'fixed',
     zIndex:'1200',
     overflowY:'auto',
     "& .MuiDrawer-paper": {
       boxSizing: "border-box",
       backgroundColor: "#101F33",
       color: "rgba(255, 255, 255, 0.7)",
     },
     "& .Mui-selected": {
       color: "#ffffff",
       backgroundColor: "rgba(30, 60, 114, 0.50) !important",
       fontWeight:600
     },
   },
  // icons: {
  //   color: "rgba(255, 255, 255, 0.7)!important",
  //   marginLeft: "20px",
  // },
  // text: {
  //   "& span": {
  //     marginLeft: "-10px",
  //     fontWeight: "600 !important",
  //     fontSize: "16px",
  //   },
  // },
};
